(() => {
  const THUMB_SEL = "xo-carousel-slide.xo-product-info-media-carousel__thumb-slide[data-media-id]";
  const FORM_SEL = "form[action*='/cart/add']";
  const ID_SEL = "input[name='id']";

  let guardUntil = 0;
  const guard = (ms = 700) => (guardUntil = Date.now() + ms);
  const guarding = () => Date.now() < guardUntil;

  function closestScope(el) {
    return el.closest("main, .product, .xo-product-info, [data-product-id]") || document;
  }

  function fire(el) {
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setOption(scope, optIndex, value) {
    if (!value) return false;

    // radios (pills)
    const radios = scope.querySelectorAll(`input[type="radio"][name^="options"]:not([disabled])`);
    if (radios.length) {
      const groups = {};
      radios.forEach(r => (groups[r.name] ||= []).push(r));
      const names = Object.keys(groups);
      const name = names[optIndex - 1];
      if (name) {
        const r = groups[name].find(x => x.value === value);
        if (r && !r.checked) {
          r.checked = true;
          fire(r);
          return true;
        }
      }
    }

    // selects
    const selects = scope.querySelectorAll(`select[name^="options"]`);
    const sel = selects[optIndex - 1];
    if (sel && sel.value !== value) {
      sel.value = value;
      fire(sel);
      return true;
    }

    return false;
  }

  function onThumb(e) {
    const thumb = e.target.closest(THUMB_SEL);
    if (!thumb) return;

    const scope = closestScope(thumb);

    const opt1 = thumb.getAttribute("data-opt1");
    const opt2 = thumb.getAttribute("data-opt2");
    const opt3 = thumb.getAttribute("data-opt3");

    // Αντιμετώπιση "snap back"
    guard(900);

    // Εφαρμόζουμε μόνο τα options που δίνει το thumbnail (συνήθως το color)
    if (opt1) setOption(scope, 1, opt1);
    if (opt2) setOption(scope, 2, opt2);
    if (opt3) setOption(scope, 3, opt3);
  }

  function blockThemeChange(e) {
    if (!guarding()) return;
    const t = e.target;
    if (!t) return;

    const isVariantSignal =
      t.matches?.(ID_SEL) ||
      t.matches?.('select[name^="options"], input[type="radio"][name^="options"]');

    if (!isVariantSignal) return;
    e.stopImmediatePropagation();
  }

  document.addEventListener("pointerdown", onThumb, true);
  document.addEventListener("click", onThumb, true);
  document.addEventListener("change", blockThemeChange, true);

  // drag/swipe: XO αλλάζει active thumb με tabindex="0"
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type !== "attributes") continue;
      const el = m.target;
      if (!(el instanceof Element)) continue;
      if (!el.matches(THUMB_SEL)) continue;
      if (m.attributeName !== "tabindex") continue;
      if (el.getAttribute("tabindex") === "0") {
        onThumb({ target: el });
      }
    }
  });

  window.addEventListener("load", () => {
    document.querySelectorAll("xo-carousel-thumbnail, xo-carousel").forEach((c) => {
      obs.observe(c, { subtree: true, attributes: true, attributeFilter: ["tabindex"] });
    });
  });
})();
